import React, { useRef, useEffect } from "react";
import TinySlider from "tiny-slider-react";
import CardComex from "./CardComex";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

import "tiny-slider/dist/tiny-slider.css";

export default function TestimoniosComex({ testimonios, color, titulo }) {
  const sliderRef = useRef(null);

  // Configuración responsive mejorada con breakpoints más específicos
  const settings = {
    items: testimonios.length === 1 ? 1 : 3, // Mostrar solo una tarjeta si hay una
    center: testimonios.length === 1, // Centrar la tarjeta si hay solo una
    gutter: 20,
    controls: true,
    mouseDrag: true,
    loop: testimonios.length > 1, // scroll infinito activado
    animateOut: "rollOut",
    navPosition: "bottom",
    controlsText: [
      `<img src=${imgI} alt="Previous" class="w-6 h-6 md:w-8 md:h-8"/>`,
      `<img src=${imgD} alt="Next" class="w-6 h-6 md:w-8 md:h-8"/>`,
    ],
    edgePadding: 10,
    responsive: {
      // Móviles pequeños (320px - 479px)
      0: {
        items: 1,
        gutter: 10,
        nav: true,
        controls: true,
      },
      // Móviles medianos (480px - 639px)
      480: {
        items: 1,
        gutter: 15,
        edgePadding: 10,
        nav: true,
        controls: true,
      },
      // Móviles grandes/Tablets pequeñas (640px - 767px)
      640: {
        items: 1,
        gutter: 15,
        edgePadding: 15,
        nav: true,
        controls: true,
      },
      // Tablets (768px - 1023px)
      768: {
        items: 2,
        gutter: 20,
        edgePadding: 20,
        nav: true,
        controls: true,
      },
      // Tablets grandes (1024px - 1199px)
      1024: {
        items: 2,
        gutter: 40,
        edgePadding: 25,
        nav: true,
        controls: true,
      },
      // Desktop pequeño (1200px - 1399px)
      1200: {
        items: 3,
        gutter: 30,
        edgePadding: 30,
        nav: true,
        controls: true,
      },
      // Desktop mediano (1400px - 1599px)
      1400: {
        items: 3,
        gutter: 35,
        edgePadding: 35,
        nav: true,
        controls: true,
      },
      // Desktop grande (1600px+)
      1600: {
        items: 3,
        gutter: 40,
        edgePadding: 40,
        nav: true,
        controls: true,
      },
    },
  };

  // Navegación mejorada con validación
  const next = () => {
    if (sliderRef.current?.slider) {
      sliderRef.current.slider.goTo("next");
    }
  };

  const prev = () => {
    if (sliderRef.current?.slider) {
      sliderRef.current.slider.goTo("prev");
    }
  };

  // Navegación por teclado
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const renderTextNode = (node, key) => {
    const { text, bold, italic } = node;

    if (!text) return null;

    let element = <span key={key}>{text}</span>;

    if (bold && italic) {
      element = (
        <strong key={key}>
          <em>{text}</em>
        </strong>
      );
    } else if (bold) {
      element = <strong key={key}>{text}</strong>;
    } else if (italic) {
      element = <em key={key}>{text}</em>;
    }

    return element;
  };

  return (
    <section aria-label="Testimonios de clientes">
      {/* Título responsive mejorado */}
      <div className="container">
        <div>
          <h1 className="text-3xl md:text-[40px] lg:text-[45px] text-left mt-[70px] md:mt-[100px] lg:mt-[90px] px-2 md:px-0 lg:px-0 lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-orange dark:text-sidom-light mb-8">
            {titulo?.titulo[0]?.children?.map((child, index) =>
              renderTextNode(child, index)
            ) || "Testimonios"}
          </h1>
        </div>
      </div>
      {/* Si solo hay un testimonio, mostrarlo centrado sin slider */}
      {testimonios?.length === 1 ? (
        <div className="flex justify-center items-center container py-8">
          <div className="max-w-md w-full sm:px-3 md:px-4 lg:px-5 mb-8 sm:mb-12 md:mb-16 lg:mb-20">
            <CardComex
              img={testimonios[0].img?.formats?.thumbnail?.url}
              logo={testimonios[0].logo?.url}
              nombre={testimonios[0].nombre}
              empresa={testimonios[0].empresa}
              cargo={testimonios[0].marca}
              texto={testimonios[0].descripcion}
            />
          </div>
        </div>
      ) : (
        <section className="testimonios-carousel-wrapper">
          <div className="container relative">
            <div className=" px-2 md:px-0 lg:px-0">
              <TinySlider settings={settings} ref={sliderRef}>
                {testimonios?.map((t, index) => (
                  <div
                    key={t.id}
                    className="px-2  w-full sm:px-3 md:px-4 lg:px-5 mb-8 sm:mb-12 md:mb-16 lg:mb-20"
                  >
                    <CardComex
                      img={t.img?.formats?.thumbnail?.url}
                      logo={t.logo?.url}
                      nombre={t.nombre}
                      empresa={t.empresa}
                      cargo={t.marca}
                      texto={t.descripcion}
                    />
                  </div>
                ))}
              </TinySlider>
            </div>
          </div>
        </section>
      )}
    </section>
  );
}
